exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "div.httpError[data-v-11559134]{height:100%}div.content[data-v-11559134]{padding-top:58px;padding-bottom:67px;background-color:#fff;min-height:100%}div.actions[data-v-11559134]{text-align:right}.logo[data-v-11559134]{display:-ms-flexbox;display:-webkit-box;display:flex;-ms-flex-align:center;-ms-flex-pack:center;-webkit-box-align:center;align-items:center;-webkit-box-pack:center;justify-content:center;background-color:#0c2340;width:175px;margin-left:auto;margin-right:auto}", ""]);

// exports
